import { PrefSwitch } from '@jarvis/platform-ui';
import { useSupportWidgetStore } from './useSupportWidgetStore';

export function SupportWidgetSettingsPanel() {
  const enabled = useSupportWidgetStore((s) => s.enabled);
  const setEnabled = useSupportWidgetStore((s) => s.setEnabled);

  return (
    <section className="theme-preferences theme-preferences--first" aria-labelledby="support-widget-heading">
      <h3 id="support-widget-heading" className="theme-preferences__title">
        Support
      </h3>
      <p className="theme-preferences__hint">
        Show the Help button in the lower-right corner to open the IT service desk.
      </p>
      <div className="theme-preferences__section">
        <div className="theme-preferences__compact-row">
          <PrefSwitch
            checked={enabled}
            onChange={setEnabled}
            aria-label="Enable support button"
          />
          <span className="theme-preferences__hint theme-preferences__hint--inline">
            Enable support button
          </span>
        </div>
      </div>
    </section>
  );
}
